import type { AuthoredSonicsState, EmotionalIntentSegment, FxIntentNode } from "./sonics.types";

export function selectEmotionalIntentSegments(
  state: AuthoredSonicsState,
): EmotionalIntentSegment[] {
  return state.emotionalIntentOrder
    .map((id) => state.emotionalIntentSegmentsById[id])
    .filter((segment): segment is EmotionalIntentSegment => Boolean(segment));
}

export function selectFxIntentNodes(
  state: AuthoredSonicsState,
): FxIntentNode[] {
  return state.fxIntentOrder
    .map((id) => state.fxIntentNodesById[id])
    .filter((node): node is FxIntentNode => Boolean(node));
}

export function selectActiveEmotionalIntentSegments(
  state: AuthoredSonicsState,
): EmotionalIntentSegment[] {
  return selectEmotionalIntentSegments(state).filter((segment) => segment.authoredBy === "authored");
}

export function selectActiveFxIntentNodes(
  state: AuthoredSonicsState,
): FxIntentNode[] {
  return selectFxIntentNodes(state).filter((node) => node.authoredBy === "authored");
}

export function selectEmotionalIntentSegmentsInRange(
  state: AuthoredSonicsState,
  startSec: number,
  endSec: number,
): EmotionalIntentSegment[] {
  return selectEmotionalIntentSegments(state).filter(
    (segment) => segment.endSec >= startSec && segment.startSec <= endSec,
  );
}

export function selectFxIntentNodesInRange(
  state: AuthoredSonicsState,
  startSec: number,
  endSec: number,
): FxIntentNode[] {
  return selectFxIntentNodes(state).filter(
    (node) => node.endSec >= startSec && node.startSec <= endSec,
  );
}